import { gql } from "@apollo/client";

export const CREATE_ORDER = gql`
  mutation CREATE_ORDER {
    createOrder {
      order {
        id
      }
    }
  }
`;

export const SAPES_GET_ORDERS = gql`
  query SAPES_GET_ORDERS {
    orders {
      total
      results {
        id
        customer {
          id
          name
        }
        state
        odooSalesOrderClientOrderRef
        odooSalesOrderId
        odooSalesOrderName
        createdAt
        createdBy {
          id
          email
        }
      }
    }
  }
`;

const ORDER_DETAIL_FRAGMENT = gql`
  fragment orderDetail on OrderType {
    id
    warehouseName
    stockCategory {
      id
      name
      stocks {
        id
        product {
          id
          odooId
          number
          name
          itemsPerSet
        }
        latestQty
      }
    }
    customer {
      id
      name
    }
    pricelist {
      id
      currency
      latestPrices {
        id
        productId
        price
      }
    }
    state
    notes

    odooPricelistId
    exchangeRate

    odooSalesOrderClientOrderRef
    odooPaymentTermsId
    odooTaxId
    odooIncoterm
    odooXDeliverymethod
    odooSalesOrderId
    odooSalesOrderName
    autoSyncToOdoo

    orderLines {
      id
      product {
        id
        odooId
        number
        name
        itemsPerSet
      }
      qty
      salesPrice
      discountPercentage
    }
  }
`;

export const GET_ORDER_INFO = gql`
  query GET_ORDER_INFO($id: ID!) {
    odooActiveCurrencies(company: "AB", refresh: false)
    odooPricelists(company: "AB")
    stockCategories {
      id
      name
    }
    order(id: $id) {
      ...orderDetail
    }
    stockCategoryLatestStocks(wisSalesOrderId: $id)
  }
  ${ORDER_DETAIL_FRAGMENT}
`;

export const SAVE_ORDER = gql`
  mutation SAVE_ORDER(
    $id: ID!
    $orderLines: [SaveOrderLineInputType]
    $input: SaveOrderInputType!
  ) {
    saveSalesOrder(id: $id, orderLines: $orderLines, input: $input) {
      order {
        ...orderDetail
      }
    }
  }
  ${ORDER_DETAIL_FRAGMENT}
`;

export const ORDER_UPDATE_STATE = gql`
  mutation ORDER_UPDATE_STATE($id: ID!, $operation: String!) {
    orderUpdateState(id: $id, operation: $operation) {
      order {
        id
        state
        odooSalesOrderId
        odooSalesOrderName
      }
    }
  }
`;

export const SAVE_ORDER_LINE = gql`
  mutation SAVE_ORDER_LINE($id: ID, $input: SaveOrderLineInputType!) {
    saveOrderLine(id: $id, input: $input) {
      orderLine {
        id
      }
    }
  }
`;

export const DELETE_ORDER_LINE = gql`
  mutation DELETE_ORDER_LINE($id: ID!) {
    deleteOrderLine(id: $id) {
      orderLine {
        id
      }
    }
  }
`;

export const SALES_DELETE_ORDER = gql`
  mutation SALES_DELETE_ORDER($id: ID!) {
    salesDeleteOrder(id: $id) {
      result
    }
  }
`;
